import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { DeleteProjectSpocsRPC } from "./deleteProjectSpocsRPC";

export class DeleteProjectSpocsRPCClientImpl extends DeleteProjectSpocsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: DeleteProjectSpocsRPC.Request): Promise<LeoRPCResult<DeleteProjectSpocsRPC.Response, DeleteProjectSpocsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "spoc-management/DeleteProjectSpocs",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      DeleteProjectSpocsRPC.ResponseDTO,
      DeleteProjectSpocsRPC.Errors.ErrorsDTO,
      DeleteProjectSpocsRPC.Response,
      DeleteProjectSpocsRPC.Errors.Errors
    >(
      response,
      "spoc-management/DeleteProjectSpocs",
      DeleteProjectSpocsRPC.Response.fromDTO,
      DeleteProjectSpocsRPC.Errors.fromDTO
    );
  }
}
